import {Status} from "../../../models/enums";
import {useState} from "react";
import {apiInstance} from "../../../api/api";
import NotificationService from "../../../services/NotificationService";
import LoggerService from "../../../services/LoggerService";
import {useTranslation} from "react-i18next";
import {OnSuccess} from "../../../utils/CallbackUtils";
import {useInvalidateSymbolQueries} from "./useInvalidateSymbolQueries";

interface UseRenameSymbolGroupHook {
	saveStatus: Status,
	renameSymbolGroup: (newName: string) => void,
}

function useRenameSymbolGroup(symbolGroupId: string, onSuccess: OnSuccess): UseRenameSymbolGroupHook {

	const {t} = useTranslation();

	const [saveStatus, setSaveStatus] = useState(Status.IDLE);
	const {invalidateSymbolQueries}= useInvalidateSymbolQueries();

	function renameSymbolGroup(newName: string) {
		setSaveStatus(Status.LOADING);
		apiInstance.symbolsApi.putSymbolGroup(newName, symbolGroupId)
			.then(() => {
				invalidateSymbolQueries()
				setSaveStatus(Status.SUCCESS);
				NotificationService.successNotification(t("common.success"),
					t("settings.tabs.symbols.groups.dropdown.rename.renameSuccessDesc"));
				onSuccess();
			})
			.catch(err => {
				setSaveStatus(Status.ERROR);
				NotificationService.errorNotification(t("common.error"),
					t("settings.tabs.symbols.groups.dropdown.rename.renameErrorDesc"));
				LoggerService.logError(err);
			});
	}

	return {saveStatus, renameSymbolGroup}
}

export default useRenameSymbolGroup;
